import { apiClient } from 'api'
import { TrainingGamePlayer } from 'types/game-player'

export const getTrainingGamesPlayers = () => apiClient.get<TrainingGamePlayer[]>('/training-players-to-games')

export const getTrainingGamePlayers = (gameId: number) =>
    apiClient.get<TrainingGamePlayer[]>(`/training-players-to-games/game/${gameId}`)

export const changePlayerToGameStatus = (telegramId: number, gameId: number, reserve: number) =>
    apiClient.patch(`training-players-to-games/${telegramId}/${gameId}`, { reserve })

// export const getTrainingGamePlayerById = (gamePlayerId: number) => apiClient.get<TrainingGamePlayer>(`/training-games/${gameId}`)

// export const createTrainingGamePlayer = (game: NewTrainingGameFormData) =>
//     apiClient.post<unknown, TrainingGamePlayer>('/training-games', game)
//
// export const editTrainingGamePlayer = (game: EditTrainingGameFormData) =>
//     apiClient.patch<EditTrainingGameFormData>(`/training-games/${game.id}`, game)
//
// export const deleteTrainingGamePlayer = (id: number) => apiClient.delete(`/training-games/${id}`)
